import React, { useState } from 'react';
import { Column } from '../../../../hooks/useTablePages';
import { ModelItem } from './Models.query';
import { Input } from '../../../../components/Form';
import { useMutation } from '@apollo/client';
import useNotify from '../../../../hooks/useNotify';
import { gql } from '../../gql';

const UPDATE_MODEL = gql(`
  mutation UpdateModel($modelId: ID!, $input: BackflowAssemblyModelInput!) {
    updateBackflowAssemblyModel(modelId: $modelId, input: $input) {
      id
      name
    }
  }
`);

const EditName: React.FC<EditNameProps> = ({ model }) => {
  const [name, setName] = useState(model.name);
  const { showError, showSuccess } = useNotify();

  const [updateModel] = useMutation(UPDATE_MODEL, {
    onCompleted: () => {
      showSuccess('Model updated');
    },
    onError: (error) => {
      showError('Error updating model', error);
    },
  });

  return (
    <Input
      sx={{
        font: 'inherit',
        height: 24,
        background: 'none',
        border: 'none',
        ':focus': {
          background: 'white',
        },
      }}
      onChange={(e) => setName(e.target.value)}
      onKeyUp={(e) => {
        if (e.key === 'Enter') {
          e.currentTarget.blur();
        }
      }}
      onBlur={() => {
        if (name === model.name) {
          return;
        }
        updateModel({
          variables: {
            modelId: model.id,
            input: {
              name,
              backflowAssemblyMakeId: model.backflowAssemblyMakeId,
              visible: model.visible,
            },
          },
        });
      }}
      defaultValue={name}
      autoComplete="off"
    />
  );
};

type EditNameProps = {
  model: ModelItem;
};

const columns: Column[] = [
  {
    header: 'Id',
    accessor: 'id',
    width: 70,
  },
  {
    header: 'Make',
    accessor: 'backflowAssemblyMake.name',
    width: 170,
  },
  {
    header: 'Name',
    id: 'name',
    accessor: (row: ModelItem) => {
      return <EditName key={row.id} model={row} />;
    },
    stringAccessor: (row: ModelItem) => {
      return row.name;
    },
    width: 200,
  },
  // {
  //  header: 'Visible',
  //   accessor: 'visible',
  //   width: 120,
  // },
];

export default columns;
